import { memo, useMemo } from 'react'
import { EMBED_HTML_PDP_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'
import { useIsClient } from 'src/hooks/useIsClient'
import { Statsig } from 'src/sdk/statsig'
import { sanitizeProductCustomHtml } from 'src/utils/sanitizeProductCustomHtml'

import type { Product } from '../../types/product'
import { getProductSectionHtml } from '../../utils/getProductSectionHtml'

type ProductCustomHtmlProps = {
  product: Product
}

function ProductCustomHtmlComponent({ product }: ProductCustomHtmlProps) {
  const isExperimentEnabled = Statsig.useStatsigFeatureGateValue(
    EMBED_HTML_PDP_EXPERIMENT_ID
  )

  const rawCustomHtml = useMemo(() => getProductSectionHtml(product), [product])

  const isClient = useIsClient()

  const sanitizedCustomHtml = useMemo(
    () => (isClient ? sanitizeProductCustomHtml(rawCustomHtml) : ''),
    [isClient, rawCustomHtml]
  )

  if (!isExperimentEnabled || !sanitizedCustomHtml) {
    return null
  }

  return (
    <section className="max-w-[1280px] mx-auto mt-6 px-4 restructure-tablet:px-0">
      <div
        className="w-full text-restructure-primary text-body-md [&_img]:max-w-full [&_img]:h-auto [&_a]:underline [overflow-wrap:anywhere]"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: sanitizedCustomHtml,
        }}
      />
    </section>
  )
}

export const ProductCustomHtml = memo(ProductCustomHtmlComponent)
